export const SET_LOADING = 'SET_LOADING';
export const UNSET_LOADING = 'UNSET_LOADING';
export const GET_SELECTOPTION = 'GET_SELECTOPTION';